import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-10 sm:py-14 md:py-20 px-4 sm:px-6 flex flex-col items-center justify-center relative" data-id="element-22" data-mp="2lcg7jutkruva">
      <div className="w-full max-w-4xl text-center relative z-10" data-id="element-23" data-mp="2gckbchr4d7qa">
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-heading text-lg sm:text-xl md:text-3xl text-brand-offWhite leading-relaxed font-light tracking-wide" data-id="element-24" data-mp="2gewqyo9en606">
          We partner with ideas, operators, and projects positioned at the edge
          of culture and technology.
        </motion.p>
      </div>
    </section>;
}